import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdsTypeCreationFormComponent } from '../../components/ads-type-creation-form/ads-type-creation-form.component';
import { AdsType } from '~core/models/ads-type.models';

@Component({
  selector: 'ads-type-creation-dialog',
  standalone: true,
  imports: [AdsTypeCreationFormComponent],
  templateUrl: './ads-type-creation-dialog.component.html',
  styleUrl: './ads-type-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdsTypeCreationDialogComponent extends BaseComponent {
  adsType = input<AdsType>();
}
